import angular from 'angular'

export default angular.module('outputManage.FOManage.redInfo', [])



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/redInfoModule.js